import React from 'react';
import { Box } from '@mui/material';
import { SonosSpeaker } from '../../services/sonosApi';
import SoundBars from './SoundBars';
import { getSonosCardMarqueeParts } from './sonosCardMarquee';
import { SONOS_BLUE } from './sonosUiStyles';

interface SonosCardMarqueeProps {
  speaker: SonosSpeaker;
  animating?: boolean;
}

const MarqueeContent: React.FC<{ prefix: string; title: string | null }> = ({ prefix, title }) => (
  <>
    {prefix ? (
      <>
        <Box component="span" sx={{ color: '#aaa' }}>{prefix}</Box>
        {title ? <Box component="span" sx={{ color: '#aaa' }}> · </Box> : null}
      </>
    ) : null}
    {title ? <Box component="span" sx={{ color: SONOS_BLUE }}>{title}</Box> : null}
  </>
);

const SonosCardMarquee: React.FC<SonosCardMarqueeProps> = ({ speaker, animating = false }) => {
  const { prefix, title } = getSonosCardMarqueeParts(speaker);
  const plain = [prefix, title].filter(Boolean).join(' · ') || '';
  const trimmed = plain.trim();
  // Sin now-playing (p. ej. cola vaciada): no barras ni texto fantasma.
  if (!trimmed || trimmed === '—') {
    return null;
  }
  const shouldAnimate = trimmed.length > 8;

  const line = shouldAnimate ? (
    <Box sx={{ overflow: 'hidden', width: '100%', minWidth: 0 }}>
      <Box
        sx={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          fontSize: 11,
          animation: 'audioMarquee 14s linear infinite',
          willChange: 'transform',
          '@keyframes audioMarquee': {
            '0%': { transform: 'translateX(0)' },
            '100%': { transform: 'translateX(-50%)' },
          },
        }}
      >
        <MarqueeContent prefix={prefix} title={title} />
        <Box component="span" sx={{ color: '#aaa' }}>   ·   </Box>
        <MarqueeContent prefix={prefix} title={title} />
      </Box>
    </Box>
  ) : (
    <Box sx={{
      fontSize: 11,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      minWidth: 0,
    }}>
      <MarqueeContent prefix={prefix} title={title} />
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, width: '100%' }}>
      <SoundBars active={animating} height={14} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {trimmed ? line : <Box sx={{ fontSize: 11, color: '#aaa' }}> </Box>}
      </Box>
    </Box>
  );
};

export default SonosCardMarquee;
